export { default } from './Input';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Input/index.js
// module id = 190
// module chunks = 0